<template>
        <div :class="`col d-flex flex-column ${(shopId === shopNameData.noppakao || shopId === shopNameData.testNoppakao || shopId === shopNameData.betaskPos) ? 'justify-content-between' : ''}`">
          <div :class="`d-flex flex-row ${(shopId === shopNameData.noppakao || shopId === shopNameData.testNoppakao || shopId === shopNameData.betaskPos) ? 'space-top' : ''}`">
            <div class="col-6 d-flex flex-column justify-content-center align-items-center">
              <div v-if="shopId !== shopNameData.noppakao && shopId !== shopNameData.testNoppakao && shopId !== shopNameData.betaskPos">
                <span class="text-Header">Number</span>
              </div>
              <div :class="!isPortrait ? 'mb-6' : ''">
                <span
                  v-if="isPortrait"
                  :class="(shopId === shopNameData.noppakao || shopId === shopNameData.testNoppakao || shopId === shopNameData.betaskPos) ? 'text-white text-sub-noppakao' : 'text-sub'">
                  {{ textRunNo }}
                </span>
                <span
                  v-if="!isPortrait"
                  :class="(shopId === shopNameData.noppakao || shopId === shopNameData.testNoppakao || shopId === shopNameData.betaskPos) ? 'text-sub-noppakao text-color' : 'text-sub'">
                  {{ textRunNo }}
                </span>
              </div>
            </div>
            <div class="col-6 d-flex flex-column justify-content-center align-items-center">
              <div v-if="shopId !== shopNameData.noppakao && shopId !== shopNameData.testNoppakao && shopId !== shopNameData.betaskPos">
                <span class="text-Header">Counter</span>
              </div>
              <div :class="!isPortrait ? 'mb-6' : ''">
                <span
                  v-if="isPortrait"
                  :class="(shopId === shopNameData.noppakao || shopId === shopNameData.testNoppakao || shopId === shopNameData.betaskPos) ? 'text-white text-sub-noppakao' : 'text-sub'">
                  {{ textCounter }}
                </span>
                <span
                  v-if="!isPortrait"
                  :class="(shopId === shopNameData.noppakao || shopId === shopNameData.testNoppakao || shopId === shopNameData.betaskPos) ? 'text-sub-noppakao text-color' : 'text-sub'">
                  {{ textCounter }}
                </span>
              </div>
            </div>
            </div>
            <div v-if="(shopId === shopNameData.noppakao || shopId === shopNameData.testNoppakao || shopId === shopNameData.betaskPos) && isPortrait" v-for="(indexIf) in limitRow" :key="indexIf" :class="`d-flex flex-row my-1 ${bookingUse && bookingUse.length > 0 ? bookingUse.length >= indexIf ? 'service' : 'none-service' : 'none-service'}`" style="gap: 10px;">
              <div class="d-flex justify-content-center align-items-center col-left-noppakao" style="flex-basis: 45%; flex-grow: 1;">
                <span class="text-service-noppakao">{{bookingUse && bookingUse.length > 0  ? bookingUse.length >= indexIf ? bookingUse[indexIf-1].storeFrontQueue  : '' : ''}}</span>
              </div>
              <div class="d-flex justify-content-center align-items-center col-right-noppakao" style="flex-basis: 45%; flex-grow: 1;">
                <span class="text-service-noppakao">{{bookingUse && bookingUse.length > 0 ? bookingUse.length >= indexIf ? bookingUse[indexIf-1].storeFrontQueue ? bookingUse[indexIf-1].servicePoint ? bookingUse[indexIf-1].servicePoint : textRunQueue : '' : '' : ''}}</span>
              </div>
            </div>
            <div v-if="(shopId === shopNameData.noppakao || shopId === shopNameData.testNoppakao || shopId === shopNameData.betaskPos) && !isPortrait" v-for="(indexIf) in limitRow" :key="indexIf" :class="`d-flex flex-row my-1 mb-2 ${bookingUse && bookingUse.length > 0 ? bookingUse.length >= indexIf ? 'service-noppakao' : 'none-service-noppakao' : 'none-service-noppakao'}`">
              <div class="d-flex justify-content-center align-items-center col-left-noppakao-landscape" style="flex-basis: 45%; flex-grow: 1;">
                <span class="text-service-noppakao text-color-queue">{{bookingUse && bookingUse.length > 0  ? bookingUse.length >= indexIf ? bookingUse[indexIf-1].storeFrontQueue  : '' : ''}}</span>
              </div>
              <div class="d-flex justify-content-center align-items-center col-right-noppakao-landscape" style="flex-basis: 45%; flex-grow: 1;">
                <span class="text-service-noppakao text-color-queue">{{bookingUse && bookingUse.length > 0 ? bookingUse.length >= indexIf ? bookingUse[indexIf-1].storeFrontQueue ? bookingUse[indexIf-1].servicePoint ? bookingUse[indexIf-1].servicePoint : textRunQueue : '' : '' : ''}}</span>
              </div>
            </div>

            <div v-if="!((shopId === shopNameData.noppakao || shopId === shopNameData.testNoppakao || shopId === shopNameData.betaskPos) && (isPortrait || !isPortrait))" v-for="(index) in 6" :key="index" :class="`d-flex flex-row row-service my-1 ${bookingUse && bookingUse.length > 0 ? bookingUse.length >= index ?  'service' : 'none-service' : 'none-service'}`" >
              <div class="col-6 d-flex justify-content-center align-items-center col-left py-0"><span class="text-service">{{bookingUse && bookingUse.length > 0  ? bookingUse.length >= index ? bookingUse[index-1].storeFrontQueue  : '': ''}}</span></div>
              <div class="col-6 d-flex justify-content-center align-items-center col-right py-0"><span class="text-service">{{bookingUse && bookingUse.length > 0  ? bookingUse.length >= index ? bookingUse[index-1].storeFrontQueue ? bookingUse[index-1].servicePoint ? bookingUse[index-1].servicePoint : textRunQueue : '' : '' : ''}}</span></div>
            </div>
        </div>
</template>
<script>
export default {
  props: {
    bookingUse: { type: Array, default: () => [] },
    isPortrait: {type: Boolean, default: false},
    textRunQueue: { type: String, default: 'เรียกคิว' },
    shopId: { type: String, default: '' },
    textRunNo: { type: String, default: 'หมายเลขคิว' },
    textCounter: { type: String, default: 'ช่องบริการ' },
    limitRow: { type: Number, default: 6 }
  }
}
</script>
<style scoped>
  .col-left-noppakao-landscape {
    background: #FCF9FF;
    color: #9845EA;
    border-top: 2px solid #9845EA; /* เส้นขอบด้านบน */
    border-left: 2px solid #9845EA; /* เส้นขอบด้านซ้าย */
    border-bottom: 2px solid #9845EA;
    border-radius: 14px 0 0 14px;
    overflow: hidden;
  }
  .col-right-noppakao-landscape {
    background: #FCF9FF;
    color: #9845EA;
    border-top: 2px solid #9845EA;
    border-right: 2px solid #9845EA; /* เส้นขอบด้านบน */
    border-bottom: 2px solid #9845EA;
    border-radius: 0 14px 14px 0;
    overflow: hidden;
  }
  .col-left-noppakao {
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.95));
    color: #7912DB;
    border-radius: 8px;
    overflow: hidden;
  }
  .col-right-noppakao {
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.95));
    color: #7912DB;
    border-radius: 8px;
    overflow: hidden;
  }
  .col-left{
    background-color: #fff;
  }
  .col-right{
    background-color: rgba(255, 255, 255, 0.3);
  }
  .row-service{
    border-radius: 20px;
    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.4);
    overflow: hidden;
  }
  .text-Header, .text-sub, .text-service{
    font-weight: 700;
  }
  .text-service-noppakao{
    font-weight: 100;
  }
  .text-color-queue {
    color: #9A48EB;
  }
  .service{
    min-height: 8vh;
  }
  .none-service{
    min-height: 8vh;
  }
  .text-number-waiting{
    font-size: 1.8vw;
    text-align: center;
  }
  .text-color{
    color: #7912DB;
  }
  @media screen and (orientation: portrait) {
  .text-service {
    font-size: 5vw;
  }
  .text-sub{
    font-size: 3vw;
  }
  .text-Header {
    font-size: 4vw;
  }
  .service{
    min-height: 5vh;
  }
  .none-service{
    min-height: 5vh;
  }
}

@media screen and (orientation: landscape) {
  .text-service, .text-service-noppakao {
    font-size: 3.5vw;
  }
  .text-service-noppakao{
    font-weight: 900;
  }
  .text-sub{
    font-size: 1.8vw;
  }
  .text-sub-noppakao{
    font-size: 2.5vw;
    font-weight: 900;
  }
  .text-Header {
    font-size: 3.5vw;
  }
  .service{
    min-height: 10vh;
  }
  .service-noppakao{
    min-height: 14vh;
  }
  .none-service{
    min-height: 10vh;
  }
  .none-service-noppakao{
    min-height: 14vh;
  }
  .text-service-noppakao{
    font-weight: 900;
  }
}

@media screen and (orientation: landscape) and (min-width: 768px){
  .service-noppakao, .none-service-noppakao{
    height: 50vh;
    padding: 0.6vh;
  }
  .col-left-noppakao-landscape {
    border-top: 1px solid #9845EA; /* เส้นขอบด้านบน */
    border-left: 1px solid #9845EA; /* เส้นขอบด้านซ้าย */
    border-bottom: 1px solid #9845EA;
    border-radius: 14px 0 0 14px;
  }
  .col-right-noppakao-landscape {
    background: #FCF9FF;
    color: #9845EA;
    border-top: 1px solid #9845EA;
    border-right: 1px solid #9845EA; /* เส้นขอบด้านบน */
    border-bottom: 1px solid #9845EA;
    border-radius: 0 14px 14px 0;
  }
}

@media screen and (orientation: landscape) and (min-width: 992px){
  .service-noppakao, .none-service-noppakao{
    height: 50vh;
    padding: 0.6vh;
  }
  .col-left-noppakao-landscape {
    border-top: 1px solid #9845EA; /* เส้นขอบด้านบน */
    border-left: 1px solid #9845EA; /* เส้นขอบด้านซ้าย */
    border-bottom: 1px solid #9845EA;
    border-radius: 14px 0 0 14px;
  }
  .col-right-noppakao-landscape {
    background: #FCF9FF;
    color: #9845EA;
    border-top: 1px solid #9845EA;
    border-right: 1px solid #9845EA; /* เส้นขอบด้านบน */
    border-bottom: 1px solid #9845EA;
    border-radius: 0 14px 14px 0;
  }
}

@media screen and (orientation: landscape) and (min-width: 1200px){
  .service-noppakao, .none-service-noppakao{
    height: 50vh;
    padding: 0.6vh;
  }
  .col-left-noppakao-landscape {
    border-top: 1px solid #9845EA; /* เส้นขอบด้านบน */
    border-left: 1px solid #9845EA; /* เส้นขอบด้านซ้าย */
    border-bottom: 1px solid #9845EA;
    border-radius: 14px 0 0 14px;
  }
  .col-right-noppakao-landscape {
    background: #FCF9FF;
    color: #9845EA;
    border-top: 1px solid #9845EA;
    border-right: 1px solid #9845EA; /* เส้นขอบด้านบน */
    border-bottom: 1px solid #9845EA;
    border-radius: 0 14px 14px 0;
  }
}

@media screen and (orientation: landscape) and (min-width: 1400px){
  .service-noppakao, .none-service-noppakao{
    height: 50vh;
    padding: 0.6vh;
  }
  .col-left-noppakao-landscape {
    border-top: 2px solid #9845EA; /* เส้นขอบด้านบน */
    border-left: 2px solid #9845EA; /* เส้นขอบด้านซ้าย */
    border-bottom: 2px solid #9845EA;
    border-radius: 14px 0 0 14px;
  }
  .col-right-noppakao-landscape {
    background: #FCF9FF;
    color: #9845EA;
    border-top: 2px solid #9845EA;
    border-right: 2px solid #9845EA; /* เส้นขอบด้านบน */
    border-bottom: 2px solid #9845EA;
    border-radius: 0 14px 14px 0;
  }
}

@media screen and (orientation: landscape) and (min-width: 1570px){
  .service-noppakao, .none-service-noppakao{
    height: 50vh;
    padding: 0.6vh;
  }
  .col-left-noppakao-landscape {
    border-top: 2px solid #9845EA; /* เส้นขอบด้านบน */
    border-left: 2px solid #9845EA; /* เส้นขอบด้านซ้าย */
    border-bottom: 2px solid #9845EA;
    border-radius: 14px 0 0 14px;
  }
  .col-right-noppakao-landscape {
    background: #FCF9FF;
    color: #9845EA;
    border-top: 2px solid #9845EA;
    border-right: 2px solid #9845EA; /* เส้นขอบด้านบน */
    border-bottom: 2px solid #9845EA;
    border-radius: 0 14px 14px 0;
  }
}

@media screen and (orientation: landscape) and (min-width: 2000px){
  .service-noppakao, .none-service-noppakao{
    height: 50vh;
    padding: 0.6vh;
  }
  .col-left-noppakao-landscape {
    border-top: 3px solid #9845EA; /* เส้นขอบด้านบน */
    border-left: 3px solid #9845EA; /* เส้นขอบด้านซ้าย */
    border-bottom: 3px solid #9845EA;
    border-radius: 24px 0 0 24px;
  }
  .col-right-noppakao-landscape {
    background: #FCF9FF;
    color: #9845EA;
    border-top: 3px solid #9845EA;
    border-right: 3px solid #9845EA; /* เส้นขอบด้านบน */
    border-bottom: 3px solid #9845EA;
    border-radius: 0 24px 24px 0;
  }
}

@media screen and (orientation: landscape) and (min-width: 3000px){
  .service-noppakao, .none-service-noppakao{
    height: 50vh;
    margin: 0.6vh;
  }
  .col-left-noppakao-landscape {
    border-top: 4px solid #9845EA; /* เส้นขอบด้านบน */
    border-left: 4px solid #9845EA; /* เส้นขอบด้านซ้าย */
    border-bottom: 4px solid #9845EA;
    border-radius: 34px 0 0 34px;
  }
  .col-right-noppakao-landscape {
    background: #FCF9FF;
    color: #9845EA;
    border-top: 4px solid #9845EA;
    border-right: 4px solid #9845EA; /* เส้นขอบด้านบน */
    border-bottom: 4px solid #9845EA;
    border-radius: 0 34px 34px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TV/BookingUse.vue